import { RENOVATION_HOUSE } from 'constants/constants';
import * as yup from 'yup';
import { getPartOfValidationSchema } from '../../helpers';

const validationSchema = yup
  .object()
  .shape({ ...getPartOfValidationSchema({ projectType: RENOVATION_HOUSE, groupName: 'energy' }) });

export default validationSchema;
